import { render } from "./UltimeSignUpModal.vue?vue&type=template&id=0552f44c"
import script from "./UltimeSignUpModal.vue?vue&type=script&lang=js"
export * from "./UltimeSignUpModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__